import { DoBootstrap, Injector, NgModule } from '@angular/core';

import { StarElement } from './star.component';
import { createCustomElement } from '@angular/elements';
import { CommonModule } from '@angular/common';

@NgModule({
    declarations: [StarElement],
    imports: [CommonModule],
    exports: [StarElement],
})
export class StarModule implements DoBootstrap {
    constructor(private injector: Injector) {}

    ngDoBootstrap(): void {
        const el = createCustomElement(StarElement, {
            injector: this.injector,
        });

        customElements.define('bazis-star', el);
    }
}
